import createDataContext from './createDataContext';
import * as actions from './actions/customerActions';
import { reducer, initialState } from './reducers/customerReducer';

export const { Context: CustomerContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
